import { render, staticRenderFns } from "./AffiliateAlertsHistory.vue?vue&type=template&id=71b274ae&scoped=true&"
import script from "./AffiliateAlertsHistory.vue?vue&type=script&lang=js&"
export * from "./AffiliateAlertsHistory.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateAlertsHistory.vue?vue&type=style&index=0&id=71b274ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b274ae",
  null
  
)

export default component.exports